import qnt from './0 phai ngay hom nay - QNT.mp3';
import dontCome from './Mademoiselle - Why don´t you come_.mp3';
import mckXvu from './mck-vu.mp3';
import thegioiconoinaochoem from './the-gioi-co-noi-nao-cho-em.mp3';
import time from './TIME - KIM KUNNI Ft. Astronormous.mp3';
import trucDoiXung from './truc-doi-xung.mp3';
import vaTheLaHet from './va-the-la-het.mp3';
import vongXoay from './vongXoay.mp3';
import nenVaHoa from './nen-va-hoa.mp3';
import tequila from './tequila.mp3';
import muonnoiVoiEm from './muon-noi-voi-em.mp3';

import thumbQnt from '../../song-thumb-nail/my-list/0-phai-hom-nay.jpg';
import thumbmckXvu from '../../song-thumb-nail/my-list/mck-vu.jpg';
import thumbthegioiconoinaochoem from '../../song-thumb-nail/my-list/the-gioi-co-noi-nao-cho-em.jpg';
import thumbTime from '../../song-thumb-nail/my-list/time.jpg';
import thumbTrucDoiXung from '../../song-thumb-nail/my-list/truc-doi-xung.jpg';
import thumbVaTheLaHet from '../../song-thumb-nail/my-list/va-the-la-het.jpg';
import thumbVongXoay from '../../song-thumb-nail/my-list/vong-xoay.jpg';
import thumbDontCome from '../../song-thumb-nail/my-list/why-dont-you-come.jpg';
import thumbNenVaHoa from '../../song-thumb-nail/my-list/nen-va-hoa.jpg';
import thumbTequila from '../../song-thumb-nail/my-list/tequila.jpg';
import thumbMuonNoiVoiEm from '../../song-thumb-nail/my-list/muon-noi-voi-em.jpg';

const vietNamPlaylist = [
    {
        name: '0 phải hôm nay',
        singer: 'QNT',
        songwriter: 'QNT',
        songSrc: qnt,
        thumbnailURL: thumbQnt,
    },
    {
        name: 'Vòng xoay',
        singer: 'Koquet',
        songwriter: 'Koquet',
        songSrc: vongXoay,
        thumbnailURL: thumbVongXoay,
    },
    {
        name: 'Why dont you come ?',
        singer: 'Modemoiselle',
        songwriter: 'Modemoiselle',
        songSrc: dontCome,
        thumbnailURL: thumbDontCome,
    },
    {
        name: 'Time',
        singer: 'KIM KUNNI',
        songwriter: 'KIM KUNNI',
        songSrc: time,
        thumbnailURL: thumbTime,
    },
    {
        name: 'Trục đối xứng',
        singer: 'KoQuet',
        songwriter: 'KoQuet',
        songSrc: trucDoiXung,
        thumbnailURL: thumbTrucDoiXung,
    },
    {
        name: 'Và thế là hết',
        singer: 'chillies',
        songwriter: 'chillies',
        songSrc: vaTheLaHet,
        thumbnailURL: thumbVaTheLaHet,
    },
    {
        name: 'Thế giới có nơi nào cho em',
        singer: 'sweet liquor',
        songwriter: 'sweet liquor',
        songSrc: thegioiconoinaochoem,
        thumbnailURL: thumbthegioiconoinaochoem,
    },
    {
        name: 'Anh đã ổn hơn x Đợi',
        singer: 'MCK x Đặng Vĩnh Thịnh',
        songwriter: 'MCK x Vũ',
        songSrc: mckXvu,
        thumbnailURL: thumbmckXvu,
    },
    {
        name: 'Nến và hoa',
        singer: 'Rhymstic',
        songwriter: 'Rhymstic',
        songSrc: nenVaHoa,
        thumbnailURL: thumbNenVaHoa,
    },
    {
        name: 'Blue tequila',
        singer: 'Táo',
        songwriter: 'Táo',
        songSrc: tequila,
        thumbnailURL: thumbTequila,
    },
    {
        name: 'Muốn nói với em',
        singer: 'T-Team & Thái Vũ',
        songwriter: 'T-Team',
        songSrc: muonnoiVoiEm,
        thumbnailURL: thumbMuonNoiVoiEm,
    },
];

export default vietNamPlaylist;
